module.exports = __webpack_public_path__ + "static/media/notes_intro_img_2.988931a7.png";